import { FC } from 'react';

import { CheckoutDesign } from '../types';

import { TOTALS } from './PreviewSection';

const MobilePreview: FC<Partial<CheckoutDesign>> = ({
  logo,
  buttonColor,
  buttonTextColor,
  primaryColor,
  textColor,
  backgroundImage,
  mobileBgImage
}) => {
  const bgImage = mobileBgImage || backgroundImage || 'none';

  return (
    <div className="w-[340px] h-[680px] bg-whitesmoke border-8 border-black rounded-[19px] flex flex-col overflow-hidden">
      {/* Top section */}
      <div
        className="flex flex-col gap-2 p-3"
        style={{
          background: primaryColor,
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top'
        }}
      >
        {/* Header */}
        <div className="flex justify-between items-center h-8">
          <img src={logo} alt="logo" className="h-10 object-contain" />
          <div style={{ color: textColor, width: 25, height: 25 }}>
            {/* Close icon */}
            <svg
              stroke="currentColor"
              fill="currentColor"
              viewBox="0 0 512 512"
              height="25px"
              width="25px"
              style={{ color: textColor }}
            >
              <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"></path>
            </svg>
          </div>
        </div>

        {/* Product Info */}
        <div className="flex flex-row gap-2 justify-between">
          <div>
            <p
              className="text-[16px] font-semibold truncate"
              style={{ color: textColor }}
            >
              Crazy Pack
            </p>
            <p
              className="text-[24px] font-semibold"
              style={{ color: textColor }}
            >
              $99.99
            </p>
          </div>
          <div
            className="flex items-center text-[12px]"
            style={{ color: textColor }}
          >
            Details
            <svg
              stroke="currentColor"
              fill="currentColor"
              viewBox="0 0 320 512"
              height="1em"
              width="1em"
              style={{ color: textColor, marginLeft: 5 }}
            >
              <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path>
            </svg>
          </div>
        </div>

        {/* Price Summary */}
        <hr className="border-t border-[#cfcfcf] w-full" />
        {TOTALS.map((row) => (
          <div key={row.label} className="flex justify-between">
            <p
              className={`${row.bold ? 'text-base font-medium' : 'text-[12px] font-normal'}`}
              style={{ color: textColor }}
            >
              {row.label}
            </p>
            <p
              className={`${row.bold ? 'text-base font-medium' : 'text-[12px] font-normal'}`}
              style={{ color: textColor }}
            >
              {row.value}
            </p>
          </div>
        ))}
      </div>

      {/* Payment Section */}
      <div className="w-full pt-1 p-1 flex flex-col items-center relative bg-[#f4f4f8] rounded-r-[15px]">
        <img
          src="./assets/images/checkout_theme_payments_mobile.png"
          alt="payments"
          className="w-full"
        />
        <div className="w-full">
          <div
            className="mt-1 mb-1 ml-1 w-[80px] h-[70px] bg-white rounded-lg flex justify-center items-center"
            style={{ border: `1px solid ${buttonColor}` }}
          >
            <img
              src="./assets/images/checkout_theme_creditcard_box.png"
              alt=""
              className="w-[73px] h-[65px]"
            />
          </div>
        </div>
        <img
          src="./assets/images/checkout_theme_creditcard_mobile.png"
          alt=""
          className="w-full"
        />
        <button
          className="w-full rounded px-4 py-3 text-lg font-medium mt-2 mb-2"
          style={{ background: buttonColor, color: buttonTextColor }}
        >
          Pay $ 15.50
        </button>
        <img
          src="./assets/images/checkout_theme_footer.png"
          alt=""
          className="w-full"
        />
      </div>
    </div>
  );
};

export default MobilePreview;
